module.exports = __webpack_public_path__ + "assets/monitors.e5450ff0.svg";